var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisaDebit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 72,
    viewBox: "0 0 99 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1979 21.2184C51.1474 25.6679 55.1702 28.1511 58.2029 29.633C61.3187 31.1474 62.3631 32.1198 62.3524 33.4752C62.3306 35.5499 59.8655 36.4646 57.5666 36.5006C53.5437 36.5657 51.2088 35.4163 49.3471 34.5488L47.8977 41.3241C49.7666 42.1826 53.2149 42.929 56.7967 42.9669C65.1969 42.9669 70.6946 38.8138 70.7235 32.3872C70.7562 24.2257 59.4354 23.7756 59.515 20.1305C59.5366 19.019 60.5956 17.8407 62.9054 17.5388C64.0548 17.3889 67.2103 17.2732 70.7959 18.9233L72.1982 12.3664C70.2753 11.6652 67.7958 10.9947 64.7161 10.9947C56.8112 10.9947 51.2449 15.1984 51.1979 21.2184ZM85.7129 11.5603C84.1804 11.5603 82.8828 12.4533 82.3081 13.8286L70.3079 42.4826H78.7044L80.3742 37.8669H90.6359L91.6009 42.4826H99L92.5443 11.5603H85.7129ZM86.8877 19.9135L89.3095 31.527H82.6768L86.8877 19.9135ZM41.0192 11.5603L34.4048 42.4826H42.4038L49.0185 11.5603H41.0192ZM29.1836 11.5603L20.8595 32.6077L17.4906 14.7124C17.0967 12.7135 15.537 11.5603 13.802 11.5603H0.189683L0 12.4587C2.79385 13.0658 5.96949 14.0435 7.8904 15.0881C9.06885 15.7279 9.4049 16.2846 9.79355 17.8046L16.1696 42.4826H24.6275L37.5892 11.5603H29.1836Z",
    fill: "url(#paint0_linear_1572_27771)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7373 50.3876V60.8012C63.4293 60.879 64.2318 60.9257 65.224 60.9257C67.2842 60.9257 68.9199 60.3909 69.9264 59.4004C70.9005 58.4245 71.4519 57.0095 71.4519 55.28C71.4519 53.5648 70.9005 52.3376 69.9408 51.4738C69.0139 50.6244 67.6131 50.1528 65.6486 50.1528C64.5624 50.1528 63.572 50.2467 62.7373 50.3876ZM64.1071 59.762V51.3782C64.4685 51.3004 65.0035 51.237 65.7101 51.237C68.6054 51.237 70.0204 52.8257 70.0042 55.3269C70.0042 58.1895 68.4317 59.8251 65.4896 59.8251C64.9566 59.8251 64.4522 59.809 64.1071 59.762Z",
    fill: "url(#paint1_linear_1572_27771)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0723 57.1504C73.0723 59.4474 74.4712 61.0052 76.8152 61.0052C78.0261 61.0052 78.8755 60.7378 79.3633 60.5173L79.1122 59.5271C78.6079 59.7458 77.9954 59.9192 77.0049 59.9192C75.6043 59.9192 74.4241 59.1493 74.3935 57.277H79.741C79.7717 57.1197 79.788 56.9155 79.788 56.6316C79.788 55.233 79.1429 53.0624 76.6417 53.0624C74.4241 53.0624 73.0723 54.8552 73.0723 57.1504ZM76.5315 54.0528C78.0893 54.0528 78.4671 55.4208 78.4508 56.2866H74.4078C74.5182 55.3269 75.1163 54.0528 76.5315 54.0528Z",
    fill: "url(#paint2_linear_1572_27771)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8955 49.6648V58.8656C81.8955 59.5415 81.8647 60.3131 81.834 60.832H83.0122L83.0918 59.5884H83.1225C83.7043 60.5804 84.5864 61.0052 85.687 61.0052C87.3858 61.0052 89.1154 59.6518 89.1154 56.9316C89.1154 54.6346 87.7943 53.0624 85.8912 53.0624C84.664 53.0624 83.784 53.5973 83.2959 54.4468H83.2652V49.6648H81.8955ZM83.3267 58.2836C83.2797 58.1264 83.2652 57.9528 83.2652 57.7812V56.4274C83.2652 56.2069 83.2959 56.0191 83.3428 55.8455C83.6268 54.8083 84.5068 54.1468 85.4358 54.1468C86.9285 54.1468 87.7146 55.4533 87.7146 56.9786C87.7146 58.7245 86.867 59.9047 85.4032 59.9047C84.3967 59.9047 83.5797 59.2432 83.3267 58.2836Z",
    fill: "url(#paint3_linear_1572_27771)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0693 51.0798C91.0693 51.5516 91.3983 51.9293 91.9025 51.9293C92.4517 51.9293 92.7825 51.5516 92.7825 51.0798C92.7825 50.592 92.4373 50.2142 91.9333 50.2142C91.4145 50.2142 91.0693 50.6083 91.0693 51.0798ZM91.241 60.832H92.6255V53.2197H91.241V60.832Z",
    fill: "url(#paint4_linear_1572_27771)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6295 51.8028V53.2196H94.4512V54.2733H95.6295V58.4245C95.6295 59.3211 95.7868 59.9987 96.1645 60.4234C96.4953 60.7849 97.0139 61.0052 97.6591 61.0052C98.1938 61.0052 98.6185 60.9112 98.8863 60.8156L98.8229 59.762C98.6185 59.825 98.3982 59.8559 98.0204 59.8559C97.2507 59.8559 96.983 59.3211 96.983 58.3775V54.2733H98.964V53.2196H96.983V51.3944L95.6295 51.8028Z",
    fill: "url(#paint5_linear_1572_27771)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1572_27771",
    x1: 0.0000121074,
    y1: 26.9808,
    x2: 99,
    y2: 26.9808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1572_27771",
    x1: 62.7372,
    y1: 55.5393,
    x2: 71.4519,
    y2: 55.5393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1572_27771",
    x1: 73.0723,
    y1: 57.0338,
    x2: 79.788,
    y2: 57.0338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1572_27771",
    x1: 81.8339,
    y1: 55.335,
    x2: 89.1154,
    y2: 55.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1572_27771",
    x1: 91.0694,
    y1: 55.5231,
    x2: 92.7825,
    y2: 55.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1572_27771",
    x1: 94.4512,
    y1: 56.1998,
    x2: 98.9639,
    y2: 56.1998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0540673,
    stopColor: "#2C244A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.360259,
    stopColor: "#262B53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683381,
    stopColor: "#1E3D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaDebit);
export default __webpack_public_path__ + "static/media/visa-debit.3c282a9acf43c07ae0284153220a6f4a.svg";
export { ForwardRef as ReactComponent };